import { render, staticRenderFns } from "./PartnerListTab.vue?vue&type=template&id=f5e673e0"
import script from "./PartnerListTab.vue?vue&type=script&lang=js"
export * from "./PartnerListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports